export default {
  isPlayGameModalOpen(state) {
    return state.isPlayGameModalOpen
  },
  isAcceptTermsModalOpen(state) {
    return state.isAcceptTermsModalOpen
  },
  isLostCodeModalOpen(state) {
    return state.isLostCodeModalOpen
  },
  getMsisdn(state) {
    state.msisdn = localStorage.getItem('msisdn')
    return state.msisdn
  },
  getRedemptionMsisdn(state) {
    state.redemptionMsisdn = localStorage.getItem('redemptionMsisdn')
    return state.redemptionMsisdn
  },
  getSelectedCodeForRedemption(state) {
    state.selectedCodeForRedemption = localStorage.getItem('currentCode')
    return state.selectedCodeForRedemption
  },
  hasFoundBonusImage(state) {
    return state.foundBonusImage
  },
  getAvailableSpins(state) {
    return state.availableSpins
  },
  getTopUpValue(state) {
    return state.topUpValue
  },
  getPpsOpenTutorial(state) {
    return state.ppsOpenTutorial
  },
  isPhysicalPrizeModalOpen(state) {
    return state.isPhysicalPrizeModalOpen
  },
  getModalPhysicalPrizeId(state) {
    return state.modalPhysicalPrizeId
  },
  isPrizeDataModalOpen(state) {
    return state.isPrizeDataModalOpen
  },
  isPrizeSmsModalOpen(state) {
    return state.isPrizeSmsModalOpen
  },
  isPrizeEuroModalOpen(state) {
    return state.isPrizeEuroModalOpen
  },
  isPrizeMinutesModalOpen(state) {
    return state.isPrizeMinutesModalOpen
  },
  physicalPrizeResponse(state) {
    return state.physicalPrizeResponse
  },
  isLoginModalOpen(state) {
    return state.isLoginModalOpen
  },
  getPassword(state) {
    return state.password
  },
  getLoginResponse(state) {
    return state.loginResponse
  },
  getAccessToken(state) {
    state.accessToken = localStorage.getItem('accessToken')
    return state.accessToken
  },
  isRegisterModalOpen(state) {
    return state.isRegisterModalOpen
  },
  getPinResponse(state) {
    return state.pinResponse
  },
  getAuthenticatePinResponse(state) {
    return state.authenticatePinResponse
  },
  getHasPasswordResponse(state) {
    return state.hasPasswordResponse
  },
  getCreatePasswordResponse(state) {
    return state.createPasswordResponse
  },
  isForgotPasswordModalOpen(state) {
    return state.isForgotPasswordModalOpen
  },
  getGameFlowState(state) {
    return state.gameFlowState
  },
  getGameResponse(state) {
    return state.gameResponse
  },
  getTelcoInfo(state) {
    return state.telcoInfo
  },
  getHasBeenAwarded(state) {
    return state.hasBeenAwarded
  },
  getExtraChance(state) {
    return state.extraChance
  },
  getPhysicalPrize(state) {
    return state.physicalPrize
  },
  getSelectedTelcoReward(state) {
    return state.selectedTelcoReward
  },
  getDeliveryDetails(state) {
    return state.deliveryDetails
  },
  isOptOutModalOpen(state) {
    return state.optOutModalOpen
  },
  getOptOutResponse(state) {
    return state.optOutResponse
  },
  getOptInResponse(state) {
    return state.optInResponse
  },
  getCheckMarketingConsentResponse(state) {
    return state.checkMarketingConsentResponse
  },
  isChangePasswordModalOpen(state) {
    return state.changePasswordModalOpen
  },
  getPhysicalDisplayedPrize(state) {
    return state.physicalDisplayedPrize
  },
  getCompareCustomerPasswordResponse(state) {
    return state.compareCustomerPasswordResponse
  },
  getChangePasswordResponse(state) {
    return state.compareCustomerPassword
  },
  getAccountResponse(state) {
    return state.accountResponse
  },
  getSumOfOpenActions(state) {
    //state.sumOfOpenActions = localStorage.getItem('sumOfOpenActions')
    return state.sumOfOpenActions
  },
  getPhysicalPrizeWinnersResponse(state) {
    return state.physicalPrizeWinners
  },
  getLastMonthWinnersResponse(state) {
    return state.lastMonthWinners
  },
  getIsCodeValidForRedeem(state){
    return state.isCodeValidForRedeem
  },
  getRegisterAsOptIn(state) {
    return state.registerAsOptIn
  },
  getInGameFlow(state) {
    state.inGameFlow = localStorage.getItem('inGameFlow')
    return state.inGameFlow
  },
  getTelcoValidRewardIds(state) {
    state.telcoValidRewardIds = localStorage.getItem('telcoIds')
    return state.telcoValidRewardIds
  },
  getIsPromoBundleCR207(state) {
    return state.isPromoBundleCR207
  },
  getIsPromoBundleCR208(state) {
    return state.isPromoBundleCR208
  },
  getIsPromoBundleCR209(state) {
    return state.isPromoBundleCR209
  },
  getIsPromoBundleIR405(state) {
    return state.isPromoBundleIR405
  },
  getPlayChances(state) {
    return state.playChances
  },
  getPlaysCount(state) {
    return state.playsCount
  },

}



// WEBPACK FOOTER //
// ./src/store/getters.js